"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
} // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions
// const { Fragment } = React
// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------

/** addMobileDetection */


var addMobileDetection = function addMobileDetection(WrappedComponent) {
  return /*#__PURE__*/function (_React$PureComponent) {
    _inheritsLoose(_class, _React$PureComponent);
    /** standard constructor */


    function _class(props) {
      return _React$PureComponent.call(this, props) || this;
    }
    /** render */


    var _proto = _class.prototype;

    _proto.render = function render() {
      // const { useMediaQuery } = this.props
      // const isExtraLargeDesktop = useMediaQuery({ minWidth: 2560 })
      // const isLargeDesktop = useMediaQuery({ minWidth: 1920 })
      // const isDesktop = useMediaQuery({ minWidth: 1024 })
      // const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1023 })
      // const isMobile = useMediaQuery({ maxWidth: 767 })
      // const isPortrait = useMediaQuery({ orientation: 'portrait' })
      // const isRetina = useMediaQuery({ minResolution: '2dppx' })
      return /*#__PURE__*/_react["default"].createElement(WrappedComponent, this.props);
    };

    return _class;
  }(_react["default"].PureComponent);
}; // ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Exports
// ----------------------------------------------------------------------------


var _default = addMobileDetection;
exports["default"] = _default;
module.exports = exports.default;